import { graphql } from "@/lib/gql/__generated__/gql";

export const updatePlanListMutation = graphql(/* GraphQL */ `
	mutation PlanListUpdate($input: PlanListInput!) {
		planListUpdate(input: $input) {
			planList {
				hotelID
				id
				plans {
					article {
						bucket
						fileName
						key
						mimeType
						region
					}
					articleTitle
					availableDiscountIDs
					availableOptionIDs
					availableRoomIDs
					billingTypeTarget
					billingTypeTerm
					cancelPolicy {
						beforeDays
						chargeRatio
					}
					checkInAvailableDayOfTheWeek
					checkInEnd
					checkInStart
					checkOut
					coSleepingKidsPrice {
						amount
						currencyType
					}
					defaultDiscountID
					doNotCountKidsAsStock
					emailTemplateReservation {
						atCanceled
						atCin
						atCreated
						atUpdated
					}
					hotelID
					id
					inSale
					isChangeOnlyOption
					isCoSleepingKidsPriceActive
					isDayTrip
					isHiddenHotelQuestions
					isNoAddressNeeded
					isPrivate
					isRequest
					isReservedAtLeastOnce
					isRoomPriceFree
					isShowRoomForGuest
					isUncancelable
					isUnchangeable
					keyVisuals {
						bucket
						fileName
						key
						mimeType
						region
					}
					kidsPolicy {
						kidsDiscountType
						kidsMaxAge
						ratio
						static {
							amount
							currencyType
						}
					}
					longStayParams {
						minimumStayDates
					}
					mainKeyVisual {
						bucket
						fileName
						key
						mimeType
						region
					}
					mainTarget
					maxDailyStockNum
					maxPeopleNumPerRoom
					maxRoomNum
					maxStockNum
					minRoomNum
					minimumPeopleNumPerRoom
					name
					notSendCinMail
					onlyUseCreditPayment
					onlyUseLocalPayment
					planID
					price {
						amount
						currencyType
					}
					questions {
						options
						question
						questionID
						questionType
						required
					}
					requiredOptionIDs
					requiredPrepMillisecond
					roomChangeDisable
					saleEnd
					saleEndTime
					saleStart
					saleStartTime
					saleStartBeforeDate
					saleTypeForTerm
					shortStayParams {
						maximumStayDates
					}
					soldNumTotal
					staticPriceParams {
						staticRoomPrices {
							prices {
								adultNum
							}
							roomID
							roomName
						}
					}
					stayableDayOfTheWeek
					stayableEnd
					stayableStart
					stockTypeTarget
					stockTypeTerm
				}
				secrets {
					articleTitle
					availableDiscountIDs
					availableOptionIDs
					availableRoomIDs
					billingTypeTarget
					billingTypeTerm
					checkInAvailableDayOfTheWeek
					checkInEnd
					checkInStart
					checkOut
					defaultDiscountID
					doNotCountKidsAsStock
					hotelID
					id
					inSale
					isChangeOnlyOption
					isCoSleepingKidsPriceActive
					isDayTrip
					isHiddenHotelQuestions
					isNoAddressNeeded
					isPrivate
					isRequest
					isReservedAtLeastOnce
					isRoomPriceFree
					isShowRoomForGuest
					isUncancelable
					isUnchangeable
					mainTarget
					maxDailyStockNum
					maxPeopleNumPerRoom
					maxRoomNum
					maxStockNum
					minRoomNum
					minimumPeopleNumPerRoom
					name
					notSendCinMail
					onlyUseCreditPayment
					onlyUseLocalPayment
					planID
					requiredOptionIDs
					requiredPrepMillisecond
					roomChangeDisable
					saleEnd
					saleEndTime
					saleStart
					saleStartTime
					saleStartBeforeDate
					saleTypeForTerm
					soldNumTotal
					stayableDayOfTheWeek
					stayableEnd
					stayableStart
					stockTypeTarget
					stockTypeTerm
				}
			}
			userErrors
		}
	}
`);
